import React from 'react'
import moment from 'moment'
import './Summary.css'
import Card, {CardHeader} from '../core/Card'
import { connect } from 'react-redux'
import numeral from 'numeral';
import { DatePicker } from 'antd';
import {updateRange} from './actions'
import twix from 'twix'
import styled, {keyframes} from 'styled-components'

const { MonthPicker, RangePicker } = DatePicker;
const rangePickerRanges = {
  YTD: [moment().startOf('year'), moment()],
  Today: [moment(), moment()],
  Month: [moment().startOf('month'), moment().endOf('month')],
  Year: [moment().startOf('year'), moment().endOf('year')],
  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
}
// keyframes returns a unique name based on a hash of the contents of the keyframes
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

const SummaryCard = styled(Card)`
  > span {
    display: flex;
    justify-content: space-between;
    margin-bottom: 3vw;
  }
  .title {
    font-size: 16px;
    text-transform: uppercase;
  }

  > span, > div {
    animation-duration: 0.5s;
    animation-name: ${props=>props.isFetchingTotals ? fadeOut : fadeIn};
    opacity: ${props=>props.isFetchingTotals ? 0 : 1};
  }

  grid-area: Summary;
  padding: 20px;

  h1 {
    text-transform: uppercase;
    font-size: 18px;
    line-height: 1em;
    padding: 0;
    margin: 0;
  }
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    div {
      align-self: center;
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      text-align: center;
      span {
        font-size: 26px;
        color: #31B59F;
      }
    }
  }

  > div {
    display: flex;
    h3 {
      font-size: 40px;
      font-weight: 700;
      margin-top: 0px;
      margin-bottom: 5px;
    }
  }

`

const Summary = connect( ({transactions})=>({
  ...transactions,
  range: transactions.filterValues.range.length>0 ? transactions.filterValues.range : rangePickerRanges['YTD'],
  totals: transactions.totals.filtered_totals || transactions.totals,
  title: transactions.filterValues.range.length>0
  ? `${
    moment(transactions.filterValues.range[0])
    .twix(
      transactions.filterValues.range[1]
    ).format({
      hideTime: true,
      monthFormat: 'MMM',
      dayFormat: 'Do'
    })
  }`
  : 'This Year'
}), {updateRange})( ({totals, range, updateRange, title, isFetchingTotals}) =>
  <SummaryCard
    isFetchingTotals={isFetchingTotals} className="Summary"
  >

    <span className="title">
      {title}
    </span>
    <div>
      <div><h3 className="revenue-total">{numeral(Math.abs(totals.total_revenue)).format('($0,0)')}</h3>Revenue</div>
      <div><h3 className="expenses-total">{numeral(Math.abs(totals.total_expenses)).format('($0,0)')}</h3>Expenses</div>
    </div>
  </SummaryCard>
)

export default Summary



// WEBPACK FOOTER //
// ./src/transactions/Summary.js